import { Component, OnInit, Input, ViewChild, ViewContainerRef, ComponentRef, ComponentFactory, ComponentFactoryResolver } from '@angular/core';
import { NodoEntity, TipoObjeto, FiltrosFormatoAsistencialEntity, FormatoAsistencialEntity } from '../../../../services/servicio-formato-asistencial.service';
import { CuadroTextoComponent } from '../cuadro-texto/cuadro-texto.component';
import { ListaDesplegableComponent } from '../lista-desplegable/lista-desplegable.component';
import { FechaComponent } from '../fecha/fecha.component';
import { MatrizComponent } from '../matriz/matriz.component';
import { TablaComponent } from '../tabla/tabla.component';
import { SeleccionUnicaComponent } from '../seleccion-unica/seleccion-unica.component';
import { Cie10Component } from '../cie10/cie10.component';
import { AcordionComponent } from '../acordion/acordion.component';
import { LabelComponent } from '../label/label.component';
import { CasillaVerificacionComponent } from '../casilla-verificacion/casilla-verificacion.component';
import { SignosVitalesComponent } from '../signos-vitales/signos-vitales.component';
import { TablaDxComponent } from '../tabla-dx/tabla-dx.component';
import { FormulaComponent } from '../formula/formula.component';
import { CondicionComponent } from '../condicion/condicion.component';
import { DiagnosticoComponent } from '../diagnostico/diagnostico.component';
import { EditorComponent } from '../editor/editor.component';
import { AudiometriaTonalComponent } from '../audiometria-tonal/audiometria-tonal.component';
import { AudiometriaVocalComponent } from '../audiometria-vocal/audiometria-vocal.component';
import { PanelComponent } from '../panel/panel.component';
import { OdontogramaComponent } from '../odontograma/odontograma.component';
import { DermatomasComponent } from '../dermatomas/dermatomas.component';
import { MatrizAgrupamientoComponent } from '../matriz-agrupamiento/matriz-agrupamiento.component';
import { AcordionTabComponent } from '../acordion/acordion-tab/acordion-tab.component';
import { AreaComponent } from '../area/area.component';
import { FechaHoraComponent } from '../fecha-hora/fecha-hora.component';

@Component({
  selector: 'app-columna',
  templateUrl: './columna.component.html',
  styleUrls: ['./columna.component.css']
})
export class ColumnaComponent implements OnInit {

  @Input() data: FormatoAsistencialEntity;
  @Input() nodo: NodoEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;
  @Input() className: string;
  @Input() index: number;
  @ViewChild('columnsContainer', { read : ViewContainerRef}) columnsContainer: ViewContainerRef;

  constructor( private componentFactory: ComponentFactoryResolver) { }

  ngOnInit() {
    this.build();
  }

  // Build
  build() {
    const tipoObjeto = this.nodo.codigoTipoObjeto;
    const impresion = this.filtros.pregunta && this.filtros.pregunta > 0 ? true : this.nodo.impresion;

    if (impresion) {
      switch (tipoObjeto) {
        case TipoObjeto.Acordion : {
          if (this.filtros.pregunta && this.filtros.pregunta > 0) {
            this.getAcordionTab();
          } else {
            this.getAcordion();
          }
        }break;
        case TipoObjeto.CasillaVerificacion : { this.getCasillaVerificacion(); }break;
        case TipoObjeto.ListaDesplegable : { this.getListaDesplegable(); } break;
        case TipoObjeto.SeleccionUnica : { this.getSeleccionUnica(); }break;
        case TipoObjeto.CuadroTexto : { this.getCuadroTexto(); }break;
        case TipoObjeto.AreaTexto : { this.getAreaTexto(); }break;
        case TipoObjeto.Tabla : { this.getTabla(); }break;
        case TipoObjeto.Matriz : { this.getMatriz(); }break;
        case TipoObjeto.Fecha : { this.getFecha(); }break;
        case TipoObjeto.FechaHora : { this.getFechaHora(); }break;
        case TipoObjeto.Formula : { this.getFormula(); }break;
        case TipoObjeto.Dermatomas : { this.getDermatomas(); }break;
        case TipoObjeto.Panel : { this.getPanel(); }break;
        case TipoObjeto.MatrizAgrupamiento : { this.getMatrizAgrupamiento(); } break;
        case TipoObjeto.Label : { this.getLabel(); }break;
        case TipoObjeto.Diagnostico : { this.getDiagnostico(); }break;
        case TipoObjeto.Editor : { this.getEditor(); }break;
        case TipoObjeto.CIE10 : { this.getControlCIE10(); }break;
        case TipoObjeto.Odontograma: { this.getOdontograma(); }break;
        case TipoObjeto.SignosVitales : { this.getSignosVitales(); }break;
        case TipoObjeto.Condicion : { this.getCondicion(); }break;
        case TipoObjeto.TablaDx : { this.getTablaDx(); }break;
        case TipoObjeto.AudiometriaTonal : { this.getAudiometriaTonal(); }break;
        case TipoObjeto.AudiometriaVocal : { this.getAudiometriaVocal(); }break;
        default : {
          // console.log('Unhanled TipoObjeto', this.nodo);
       } break;
      }
    }
  }

  // Constructores
  getListaDesplegable(): ComponentRef<ListaDesplegableComponent> {
    const factory: ComponentFactory<ListaDesplegableComponent> = this.componentFactory.resolveComponentFactory(ListaDesplegableComponent);
    const component: ComponentRef<ListaDesplegableComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.filtros = this.filtros;
      component.instance.onDelete = () => {
        this.onDetach(this.nodo);
      };
    return component;
  }

  getCuadroTexto(): ComponentRef<CuadroTextoComponent> {
    const factory: ComponentFactory<CuadroTextoComponent> = this.componentFactory.resolveComponentFactory(CuadroTextoComponent);
    const component: ComponentRef<CuadroTextoComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.filtros = this.filtros;
      component.instance.onDelete = (nodo: NodoEntity, tta: number) => {
        if (nodo.id === this.nodo.id && this.filtros.tta === tta) {
          this.onDetach(this.nodo);
        }
      };

    return component;
  }

  getAreaTexto(): ComponentRef<AreaComponent> {
    const factory: ComponentFactory<AreaComponent> = this.componentFactory.resolveComponentFactory(AreaComponent);
    const component: ComponentRef<AreaComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.filtros = this.filtros;
      component.instance.onDelete = (nodo: NodoEntity, tta: number) => {
        if (nodo.id === this.nodo.id && this.filtros.tta === tta) {
          this.onDetach(this.nodo);
        }
      }

    return component;
  }

  getFecha(): ComponentRef<FechaComponent> {
    const factory: ComponentFactory<FechaComponent> = this.componentFactory.resolveComponentFactory(FechaComponent);
    const component: ComponentRef<FechaComponent> = this.columnsContainer.createComponent(factory);
    component.instance.nodo = this.nodo;
    component.instance.filtros = this.filtros;
    component.instance.onDelete = () => {
      this.onDetach(this.nodo);
    };
    return component;
  }

  getFechaHora(): ComponentRef<FechaHoraComponent> {
    const factory: ComponentFactory<FechaHoraComponent> = this.componentFactory.resolveComponentFactory(FechaHoraComponent);
    const component: ComponentRef<FechaHoraComponent> = this.columnsContainer.createComponent(factory);
    component.instance.nodo = this.nodo;
    component.instance.filtros = this.filtros;
    component.instance.onDelete = () => {
      this.onDetach(this.nodo);
    };
    return component;
  }

  getMatriz(): ComponentRef<MatrizComponent> {
    const factory: ComponentFactory<MatrizComponent> = this.componentFactory.resolveComponentFactory(MatrizComponent);
    const component: ComponentRef<MatrizComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.filtros = this.filtros;
      component.instance.onDelete = () => {
        this.onDetach(this.nodo);
      };
    return component;
  }

  getTabla(): ComponentRef<TablaComponent> {
    const factory: ComponentFactory<TablaComponent> = this.componentFactory.resolveComponentFactory(TablaComponent);
    const component: ComponentRef<TablaComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.filtros = this.filtros;
    return component;
  }

  getSeleccionUnica(): ComponentRef<SeleccionUnicaComponent> {
    const factory: ComponentFactory<SeleccionUnicaComponent> = this.componentFactory.resolveComponentFactory(SeleccionUnicaComponent);
    const component: ComponentRef<SeleccionUnicaComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.filtros = this.filtros;
      component.instance.onDelete = () => {
        this.onDetach(this.nodo);
      };
    return component;
  }

  getControlCIE10(): ComponentRef<Cie10Component> {
    const factory: ComponentFactory<Cie10Component> = this.componentFactory.resolveComponentFactory(Cie10Component);
    const component: ComponentRef<Cie10Component> = this.columnsContainer.createComponent(factory);
      component.instance.filtros = this.filtros;
      component.instance.nodo = this.nodo;
    return component;
  }

  getAcordion(): ComponentRef<AcordionComponent> {
    const factory: ComponentFactory<AcordionComponent> = this.componentFactory.resolveComponentFactory(AcordionComponent);
    const component: ComponentRef<AcordionComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.filtros = this.filtros;
      component.instance.data = this.data;
      component.instance.onDelete = () => {
        this.onDetach(this.nodo);
      };
    return component;
  }

  getAcordionTab(): ComponentRef<AcordionTabComponent> {
    const factory: ComponentFactory<AcordionTabComponent> = this.componentFactory.resolveComponentFactory(AcordionTabComponent);
    const component: ComponentRef<AcordionTabComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.filtros = this.filtros;
      component.instance.data = this.data;
    return component;
  }

  getLabel(): ComponentRef<LabelComponent> {
    const factory: ComponentFactory<LabelComponent> = this.componentFactory.resolveComponentFactory(LabelComponent);
    const component: ComponentRef<LabelComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
    return component;
  }

  getCasillaVerificacion(): ComponentRef<CasillaVerificacionComponent> {
    const factory: ComponentFactory<CasillaVerificacionComponent> = this.componentFactory.resolveComponentFactory(CasillaVerificacionComponent);
    const component: ComponentRef<CasillaVerificacionComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
    return component;
  }

  getSignosVitales(): ComponentRef<SignosVitalesComponent> {
    const factory: ComponentFactory<SignosVitalesComponent> = this.componentFactory.resolveComponentFactory(SignosVitalesComponent);
    const component: ComponentRef<SignosVitalesComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.filtros = this.filtros;
      component.instance.data = this.data;

      component.instance.onDelete = () => {
        this.onDetach(this.nodo);
      };
    return component;
  }

  getTablaDx(): ComponentRef<TablaDxComponent> {
    const factory: ComponentFactory<TablaDxComponent> = this.componentFactory.resolveComponentFactory(TablaDxComponent);
    const component: ComponentRef<TablaDxComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.filtros = this.filtros;
    return component;
  }

  getFormula(): ComponentRef<FormulaComponent> {
    const factory: ComponentFactory<FormulaComponent> = this.componentFactory.resolveComponentFactory(FormulaComponent);
    const component: ComponentRef<FormulaComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.filtros = this.filtros;
      component.instance.data = this.data;
      component.instance.onDelete = () => {
        this.onDetach(this.nodo);
      };
    return component;
  }

  getCondicion(): ComponentRef<CondicionComponent> {
    const factory: ComponentFactory<CondicionComponent> = this.componentFactory.resolveComponentFactory(CondicionComponent);
    const component: ComponentRef<CondicionComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.filtros = this.filtros;
      component.instance.data = this.data;
      component.instance.onDelete = () => {
        this.onDetach(this.nodo);
      }
    return component;
  }

  getDiagnostico(): ComponentRef<DiagnosticoComponent> {
    const factory: ComponentFactory<DiagnosticoComponent> = this.componentFactory.resolveComponentFactory(DiagnosticoComponent);
    const component: ComponentRef<DiagnosticoComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.filtros = this.filtros;
      component.instance.data = this.data;
    return component;
  }

  getEditor(): ComponentRef<EditorComponent> {
    const factory: ComponentFactory<EditorComponent> = this.componentFactory.resolveComponentFactory(EditorComponent);
    const component: ComponentRef<EditorComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.filtros = this.filtros;
      component.instance.data = this.data;
    return component;
  }

  getAudiometriaTonal(): ComponentRef<AudiometriaTonalComponent> {
    const factory: ComponentFactory<AudiometriaTonalComponent> = this.componentFactory.resolveComponentFactory(AudiometriaTonalComponent);
    const component: ComponentRef<AudiometriaTonalComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.filtros = this.filtros;
      component.instance.data = this.data;
    return component;
  }

  getAudiometriaVocal(): ComponentRef<AudiometriaVocalComponent> {
    const factory: ComponentFactory<AudiometriaVocalComponent> = this.componentFactory.resolveComponentFactory(AudiometriaVocalComponent);
    const component: ComponentRef<AudiometriaVocalComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.filtros = this.filtros;
      component.instance.data = this.data;
    return component;
  }

  getPanel(): ComponentRef<PanelComponent> {
    const factory: ComponentFactory<PanelComponent> = this.componentFactory.resolveComponentFactory(PanelComponent);
    const component: ComponentRef<PanelComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.data = this.data;
      component.instance.filtros = this.filtros;
    return component;
  }

  getOdontograma(): ComponentRef<OdontogramaComponent> {
    const factory: ComponentFactory<OdontogramaComponent> = this.componentFactory.resolveComponentFactory(OdontogramaComponent);
    const component: ComponentRef<OdontogramaComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.data = this.data;
      component.instance.filtros = this.filtros;
    return component;
  }

  getDermatomas(): ComponentRef<DermatomasComponent> {
    const factory: ComponentFactory<DermatomasComponent> = this.componentFactory.resolveComponentFactory(DermatomasComponent);
    const component: ComponentRef<DermatomasComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.data = this.data;
      component.instance.filtros = this.filtros;
    return component;
  }

  getMatrizAgrupamiento(): ComponentRef<MatrizAgrupamientoComponent> {
    const factory: ComponentFactory<MatrizAgrupamientoComponent> = this.componentFactory.resolveComponentFactory(MatrizAgrupamientoComponent);
    const component: ComponentRef<MatrizAgrupamientoComponent> = this.columnsContainer.createComponent(factory);
      component.instance.nodo = this.nodo;
      component.instance.filtros = this.filtros;
      component.instance.onDelete = () => {
        this.onDetach(this.nodo);
      };
    return component;
  }

  // Auxiliar

  onDetach(nodo: NodoEntity) {
    setTimeout(() => {
      this.onDelete();
    }, 50);
  }

  onDelete() {  }
}
